import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { ContentLoader } from '@weave/design-system';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { Page } from '../../../../../shared';
import { injectParams, ONBOARDING } from '../../../../../../constants/paths';
import { selectCurrentLocationId } from '../../../../../../redux/actions/location';
import { HandoffSnapshot } from '../../../handoff-hub.types';

interface Props {
  snapshot: Partial<HandoffSnapshot>;
  isUpdating: boolean;
  headerActions?: ReactNode;
  children: ReactNode;
}

// Shared page chrome (title, breadcrumbs, loader) for every edit flow.
export const HandoffEditPage = ({
  snapshot,
  isUpdating,
  headerActions,
  children,
}: Props) => {
  const locationId = useSelector(selectCurrentLocationId);
  const rootHandoffHubUrl = injectParams(ONBOARDING.handoff, { id: locationId });
  const title = `${snapshot.id ? 'Edit' : 'Create'} Handoff`;

  return (
    <Page
      title={title}
      breadcrumbs={[
        { url: rootHandoffHubUrl, title: 'Handoff Hub' },
        { url: '', title },
      ]}
      headerActions={<>{headerActions}</>}
    >
      <div css={mainContainer}>
        <ContentLoader show={isUpdating} />
        {children}
      </div>
    </Page>
  );
};

const mainContainer = css`
  padding: ${theme.spacing(0, 1)};
  max-width: 1200px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
`;
